import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrcaLogoComponent } from "../../../../core/component/orca-logo-svg/orca-logo-svg.component";
import { AllIconsComponent } from "../../../shared/component/all-icons/all-icons.component";
import { OrganizationDTO } from "../../../organization/dto/OrganizationDTO";
import { OrganizationWithAccesses } from "../../../../core/component/hornavbar/dto/InitDataDTO";

@Component({
  selector: 'app-select-organization',
  imports: [
    OrcaLogoComponent,
    AllIconsComponent,
  ],
  templateUrl: './select-organization.component.html',
  styleUrls: [
    './select-organization.component.scss',
    '../../../login/entrance-group.scss',
  ],
  standalone: true,
})
export class SelectOrganizationComponent {
  @Input({ required: true }) isNewOrgCanBeCreated: boolean;
  @Input({ required: true }) availableOrganization: OrganizationWithAccesses[];
  @Input() showLogo: boolean = false;

  @Output() createOrganizationEmitter = new EventEmitter<void>();
  @Output() selectOrganizationEmitter = new EventEmitter<OrganizationDTO>();
}
